import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('cutting', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48"
  }, [_createVNode("g", {
    "stroke": "none",
    "stroke-width": props.strokeWidth,
    "fill": "none",
    "fill-rule": "evenodd",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, [_createVNode("g", {
    "transform": "translate(6.000000, 5.000000)",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, [_createVNode("g", {
    "transform": "translate(0.000000, 0.021632)"
  }, [_createVNode("polyline", {
    "points": "0 4.97836848 32 4.97836848 32 36.9783685"
  }, null), _createVNode("path", {
    "d": "M20.4664367,-6 L20.4664367,39.0238636",
    "transform": "translate(20.466437, 16.511932) rotate(-135.000000) translate(-20.466437, -16.511932) "
  }, null), _createVNode("polyline", {
    "transform": "translate(20.000000, 16.978368) scale(-1, -1) translate(-20.000000, -16.978368) ",
    "points": "4 0.978368479 36 0.978368479 36 32.9783685"
  }, null)])])])]);
});